<template>
  <div class="metal_changed_pic">
    <img src="@/images/metal_za@2x.png">
    <div class="metal-text">
      <div class="templeName">
        <div class="textContainer">
          <span class="text" v-html="textInfo[0].textContent"></span>
        </div>
      </div>
      <div class="godName text-two">
        <div class="textContainer">
          <span class="text" v-html="textInfo[1].textContent"></span>
        </div>
      </div>
      <div class="gift">
        <div class="textContainer">
          <span class="text" v-html="textInfo[2].textContent"></span>
        </div>
      </div>
      <div class="respect">
        <div class="textContainer">
          <span class="text" v-html="textInfo[3].textContent"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "../../commonMixin";
export default {
  // 大福，大統帥
  name: "customizeMetalZA",
  mixins: [commonMixin],
  mounted() {
    this.calcEmFontsizeBase();
    this.controlWrap(0, this.customTextTempleName);
    this.controlFontsize(0, this.customTextTempleName);
    this.controlWrap(1, this.customTextGodName);
    this.controlFontsize(1, this.customTextGodName);
    this.controlWrap(2, this.customTextGift);
    this.controlFontsize(2, this.customTextGift);
    this.controlWrap(3, this.customTextRespect);
    this.controlFontsize(3, this.customTextRespect);
  },
  data() {
    return {
      textInfo: [
        {
          name: "templeName",
          lineLimit: this.$store.getters.textSettingByComponentCode("ZA")
            .templeName.lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode("ZA")
            .templeName.textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode("ZA")
            .templeName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        },
        {
          name: "godName",
          lineLimit: this.$store.getters.textSettingByComponentCode("ZA")
            .godName.lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode("ZA")
            .godName.textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode("ZA")
            .godName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        },
        {
          name: "gift",
          lineLimit: this.$store.getters.textSettingByComponentCode("ZA").gift
            .lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode("ZA").gift
            .textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode("ZA").gift
            .maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        },
        {
          name: "respect",
          lineLimit: 1,
          textLimit: 2,
          maxFontsize: 20,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: ""
        }
      ]
    };
  },
  watch: {
    customTextTempleName() {
      this.controlWrap(0, this.customTextTempleName);
      this.controlFontsize(0, this.customTextTempleName);
    },
    customTextGodName() {
      this.controlWrap(1, this.customTextGodName);
      this.controlFontsize(1, this.customTextGodName);
    },
    customTextGift() {
      this.controlWrap(2, this.customTextGift);
      this.controlFontsize(2, this.customTextGift);
    },
    customTextRespect() {
      this.controlWrap(3, this.customTextRespect);
      this.controlFontsize(3, this.customTextRespect);
    }
  },
  methods: {},
  computed: {
    //得到使用者動態輸入的值
    customTextTempleName() {
      return this.$store.getters.getCutomTempleName;
    },
    customTextGodName() {
      return this.$store.getters.getCutomGodName;
    },
    customTextGift() {
      return this.$store.getters.getCutomGift;
    },
    customTextRespect() {
      return this.$store.getters.getCutomRespect;
    }
  }
};
</script>

<style scoped lang="scss">
.templeName {
  height: 28px;
  width: 223px;
  border: 1px dashed $primaryLightColor;
  margin: 0 auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 223px;
    span {
      white-space: nowrap;
    }
  }
}
.godName {
  width: 263px;
  height: 53px;
  margin: 0 auto;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 263px;
    span {
      white-space: nowrap;
    }
  }
}
.gift {
  margin: 0 17px auto auto;
  border: 1px dashed $primaryLightColor;
  width: 178px;
  height: 32px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 178px;
    span {
      white-space: nowrap;
    }
  }
}
.respect {
  width: 46px;
  position: absolute;
  bottom: 3px;
  left: 15px;
  box-sizing: border-box;
  .textContainer {
    width: 46px;
  }
}
.metal_changed_pic {
  position: relative;
  font-family: "Noto Serif TC";
  img {
    width: 100%;
  }

  .metal-text {
    position: absolute;
    top: 135px;
    left: 118px;
    color: $primaryLightColor;
    font-weight: 800;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 97px;
      left: 68px;
    }
    @include table {
      transform: scale(0.7);
      top: 78px;
      left: 43px;
    }
    @include phone {
      transform: scale(0.64);
      top: 66px;
      left: 29px;
    }
  }
}
</style>
